import { useState } from "react";
import "../SummaryEvaluation.css";

export default function SummaryEvaluationBox({
  loading,
  studentScore = 0,
  totalScore = 0,
  defaultFeedback = "",
  maxFeedbackLength = 500,
  onSubmit,
  canSubmit,
}) {
  const [feedback, setFeedback] = useState(defaultFeedback);

  const handleChange = (e) => {
    let val = e.target.value;

    if (val.length > maxFeedbackLength) {
      val = val.slice(0, maxFeedbackLength);
    }

    setFeedback(val);
  };

  const handleSubmit = () => {
    onSubmit?.(feedback);
  };

  return (
    <div className="final-eval" style={{ marginLeft: "auto" }}>
      {/* Score */}
      <div className="final-eval__score">
        <span className="final-eval__score-label">Score</span>
        <span className="final-eval__score-value">
          {studentScore} / {totalScore}
        </span>
      </div>

      {/* Feedback */}
      <div className="final-eval__field">
        <div className="final-eval__header">
          <label>Overall Feedback</label>
          <span className="final-eval__count">
            {feedback.length} / {maxFeedbackLength}
          </span>
        </div>

        <textarea
          rows={4}
          value={feedback}
          placeholder="Write overall feedback for student..."
          onChange={handleChange}
        />
      </div>

      {/* Submit */}
      <button
        disabled={!canSubmit || loading}
        className="final-eval__submit"
        onClick={handleSubmit}
      >
        {loading ? "Submitting..." : "Submit Evaluation"}
      </button>
    </div>
  );
}
